import moment from 'moment';
export const hasLegalAge = (value) => {
    const birthdate = moment(value).startOf('day');
    const today = moment().startOf('day');
    const yearsBetween = today.diff(birthdate, 'years', true);
    return yearsBetween < 18 ? 'Input.validationMessage.legalAge' : undefined;
};
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
